export default () => ({
    isOpen: false,
    mobile: false,
    active: '',

    // Allow use of Esc key to close nav
    state: {
        [':class']: 'isOpen ? "--is-open" : ""',
        [':data-light']: 'isOpen',
        ['@keydown.window.escape']() {
            this.isOpen = false
            this.active = ''
        },
        ['@click.outside']() {
            this.isOpen = false
            this.active = ''
        },
    },

    menu: {
        ['@click']() {
            this.isOpen = true

            if (this.active == this.$el.dataset.menu) {
                this.active = ''
                this.isOpen = false
                return
            }

            this.active = this.$el.dataset.menu
        },
        [':class']: 'active == $el.dataset.menu ? "--is-active" : ""',
    },

    mobileToggle: {
        ['@click']() {
            this.isOpen = !this.isOpen
            this.mobile = !this.mobile
        },
    },

    mobileNav: {
        [':class']: 'mobile ? "--is-open" : ""',
        ['x-trap.noscroll']() {
            return this.mobile == true
        },
    },

    init() {
        const set = () => {
            const h = this.$root.offsetHeight
            document.documentElement.style.setProperty('--nav-height', `${h}px`)
        }

        requestAnimationFrame(() => {
            set()
            new ResizeObserver(set).observe(this.$root)
        })
    },
})
